import classNames from "classnames";
import React from "react";

import Button, { ButtonSize, ButtonTemplate } from "components/Button";
import { CrossIcon, ErrorIcon2, InfoIcon } from "components/Icons";

import styles from "./styles.module.scss";

export enum NotificationType {
  Info = "info",
  Error = "error",
  Success = "success",
}

type Props = {
  testId?: string;
  type: NotificationType;
  title: string;
  body?: string | React.ReactNode;
  onDismiss?: () => void;
  primaryAction?: {
    value: string;
    type: ButtonTemplate;
    buttonClassName?: string;
    onAction?: () => void;
    size?: ButtonSize;
  };
  secondaryAction?: {
    value: string;
    type: ButtonTemplate;
    buttonClassName?: string;
    onAction?: () => void;
    href?: string;
    size?: ButtonSize;
  };
  className?: string;
};

export const InlineNotification = (props: Props) => {
  const {
    title,
    body,
    type,
    primaryAction,
    secondaryAction,
    onDismiss,
    testId,
    className,
  } = props;
  return (
    <div
      className={classNames(styles.wrapper, styles[type], className)}
      data-testid={testId}
    >
      <div className={styles.wrapper__main}>
        <div className={classNames(styles.title, styles[type])}>
          <div className={classNames(styles.icon, styles[type])}>
            {type === NotificationType.Error ? <ErrorIcon2 /> : <InfoIcon />}
          </div>
          {title}
        </div>
        {body && (
          <div className={classNames(styles.body, styles[type])}>{body}</div>
        )}

        {(primaryAction || secondaryAction) && (
          <div className={styles.actions}>
            {primaryAction && (
              <Button
                template={primaryAction.type}
                text={primaryAction.value}
                className={primaryAction.buttonClassName}
                onClick={primaryAction.onAction}
                size={primaryAction.size || ButtonSize.Small}
              />
            )}
            {secondaryAction && (
              <Button
                template={secondaryAction.type}
                text={secondaryAction.value}
                className={secondaryAction.buttonClassName}
                href={secondaryAction.href}
                size={secondaryAction.size || ButtonSize.Small}
              />
            )}
          </div>
        )}
      </div>
      {onDismiss && (
        <div
          className={styles.dismiss}
          onClick={onDismiss}
        >
          <CrossIcon className={styles.crossIcon} />
        </div>
      )}
    </div>
  );
};
